import { axiosInstance } from 'src/util/axios/instance.axios'
import { UnusedUserSkills, UnusedSkillsList } from '../model/unused-skills-model'

export async function getUnusedUserSkills(userId?: string): Promise<UnusedUserSkills[]> {
  const url = userId ? `/unused-skills/unused-user-skills/${userId}` : `/unused-skills/unused-user-skills/`
  const { data } = await axiosInstance.request<UnusedUserSkills[]>({
    url,
  })

  return data
}

export async function getUnusedSkillsList(): Promise<UnusedSkillsList[]> {
  const { data } = await axiosInstance.request<UnusedSkillsList[]>({
    url: `/unused-skills/unused-skills-list/`,
  })

  return data
}

export async function addUnusedSkills(skillName: string): Promise<UnusedUserSkills> {
  const { data } = await axiosInstance.request<UnusedUserSkills>({
    url: `/unused-skills/save-unused-skills/`,
    method: 'POST',
    data: { skillName },
  })

  return data
}

export async function deleteUnusedUserSkills(skillId: string): Promise<void> {
  await axiosInstance.request<any>({
    url: `/unused-skills/delete-unused-user-skills/${skillId}`,
    method: 'delete',
  })
}

export async function getUnusedUserRecommendedSkills(): Promise<UnusedSkillsList[]> {
  const { data } = await axiosInstance.request<UnusedSkillsList[]>({
    url: `/unused-skills/unused-user-recommended-skills/`,
  })

  return data
}

export async function updateUnusedUserSkillLevel(skillId: string, selectedLevel: number): Promise<void> {
  await axiosInstance.request<any>({
    url: `/unused-skills/update-unused-user-skills/${skillId}`,
    method: 'PUT',
    data: { selectedLevel },
  })
}
